/* eslint-disable max-len */
import React from 'react';
import { CommonIconProps } from './commonIconProps';

export const IconAIWidget: React.FC<CommonIconProps> = ({ className }) => (
<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
<path d="M20.0081 7.41667C16.3267 7.41667 13.3415 10.4019 13.3415 14.0833C13.3415 10.4019 10.3563 7.41667 6.6748 7.41667C10.3563 7.41667 13.3415 4.43148 13.3415 0.75C13.3415 4.43148 16.3267 7.41667 20.0081 7.41667Z" fill="#625EE9" stroke="#625EE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M9.63889 15.5651C7.18333 15.5651 5.19444 17.5539 5.19444 20.0095C5.19444 17.5539 3.20556 15.5651 0.75 15.5651C3.20556 15.5651 5.19444 13.5762 5.19444 11.1206C5.19444 13.5762 7.18333 15.5651 9.63889 15.5651Z" fill="#625EE9" stroke="#625EE9" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
);
